/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CodeType } from './CodeType';
import {
    CodeTypeFromJSON,
    CodeTypeFromJSONTyped,
    CodeTypeToJSON,
    CodeTypeToJSONTyped,
} from './CodeType';

/**
 * 
 * @export
 * @interface CodeUpdate
 */
export interface CodeUpdate {
    /**
     * 
     * @type {string}
     * @memberof CodeUpdate
     */
    name?: string | null;
    /**
     * 
     * @type {CodeType}
     * @memberof CodeUpdate
     */
    type?: CodeType | null;
    /**
     * 
     * @type {string}
     * @memberof CodeUpdate
     */
    code?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CodeUpdate
     */
    problem_id?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CodeUpdate
     */
    is_active?: boolean | null;
    /**
     * 
     * @type {Date}
     * @memberof CodeUpdate
     */
    last_used?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof CodeUpdate
     */
    blockly_workspace?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CodeUpdate
     */
    teacher_comments?: string | null;
}



/**
 * Check if a given object implements the CodeUpdate interface.
 */
export function instanceOfCodeUpdate(value: object): value is CodeUpdate {
    return true;
}

export function CodeUpdateFromJSON(json: any): CodeUpdate {
    return CodeUpdateFromJSONTyped(json, false);
}

export function CodeUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): CodeUpdate {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'type': json['type'] == null ? undefined : CodeTypeFromJSON(json['type']),
        'code': json['code'] == null ? undefined : json['code'],
        'problem_id': json['problem_id'] == null ? undefined : json['problem_id'],
        'is_active': json['is_active'] == null ? undefined : json['is_active'],
        'last_used': json['last_used'] == null ? undefined : (new Date(json['last_used'])),
        'blockly_workspace': json['blockly_workspace'] == null ? undefined : json['blockly_workspace'],
        'teacher_comments': json['teacher_comments'] == null ? undefined : json['teacher_comments'],
    };
}

export function CodeUpdateToJSON(json: any): CodeUpdate {
    return CodeUpdateToJSONTyped(json, false);
}

export function CodeUpdateToJSONTyped(value?: CodeUpdate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'type': CodeTypeToJSON(value['type']),
        'code': value['code'],
        'problem_id': value['problem_id'],
        'is_active': value['is_active'],
        'last_used': value['last_used'] == null ? undefined : ((value['last_used'] as any).toISOString()),
        'blockly_workspace': value['blockly_workspace'],
        'teacher_comments': value['teacher_comments'],
    };
}

